import React from "react";
import Breadcrumb from "../../components/Breadcrumb";
import EditChapter from "../../components/Chapter/ChapterEdit";


const ChapterEdit = () => {
  return (
    <>

 
        {/* Breadcrumb */}
        <div className="d-flex justify-content-between"><h5>Edit Chapter  </h5><Breadcrumb title="Edit Chapter" /></div>


        {/* UsersListLayer */}
        <EditChapter />


    </>
  );
};

export default ChapterEdit; 